export class DataQualityNavStatus {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "overview",
            "baseName": "overview",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "healthTrend",
            "baseName": "healthTrend",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "completeness",
            "baseName": "completeness",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "schemaChanges",
            "baseName": "schemaChanges",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "distribution",
            "baseName": "distribution",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "quarantine",
            "baseName": "quarantine",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "schemaChangesCount",
            "baseName": "schemaChangesCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "quarantineCount",
            "baseName": "quarantineCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataQualityNavStatus.attributeTypeMap;
    }
    constructor() {
    }
}
